import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'picnic-table', 'PicnicTable', [["path",{"d":"M16 7l2 9m-10 -9l-2 9m-1 -9h14m2 5h-18"}]]);